__turbopack_context__.v({
  "author": "TestimonialBlok-module__r8JIeq__author",
  "content": "TestimonialBlok-module__r8JIeq__content",
  "image": "TestimonialBlok-module__r8JIeq__image",
  "root": "TestimonialBlok-module__r8JIeq__root",
  "text": "TestimonialBlok-module__r8JIeq__text",
});
